module.exports = __webpack_public_path__ + "img/egg.be5030ca.webp";